const MIN_WIDTH_MD = 769;
const MIN_WIDTH_LG = 1025;
const MIN_WIDTH_XL = 1273;

const COLOR_CATAPULT_ORANGE = "#ff5500";
const COLOR_CATAPULT_BLACK = "#101010";
const COLOR_CATAPULT_WHITE = "#ffffff";
const COLOR_GREY_1 = "#292F33";
const COLOR_GREY_2 = "#404040";
const COLOR_GREY_3 = "#666666";
const COLOR_GREY_4 = "#808080";
const COLOR_GREY_5 = "#BFBFBF";
const COLOR_GREY_6 = "#E6E6E6";
const COLOR_GREY_7 = "#FAFAFA";
const COLOR_ORANGE_1 = "#ce4501";
const COLOR_ORANGE_2 = "#ff7633";
const COLOR_ORANGE_3 = "#f78045";
const COLOR_ORANGE_4 = "#f58e5c";
const COLOR_ORANGE_5 = "#f8a57c";
const COLOR_ORANGE_6 = "#f6b495";
const COLOR_INDIGO_1 = "#292e5d";
const COLOR_INDIGO_2 = "#31376f";
const COLOR_INDIGO_3 = "#424994";
const COLOR_INDIGO_4 = "#a9addc";
const COLOR_INDIGO_5 = "#dcdef1";
const COLOR_LTSFC_ALERT_RED = "#e91616";
const COLOR_LTSFC_ALERT_RED_BG = "#fef6f6";
const COLOR_LTSFC_ALERT_RED_TEXT = "#a71010";
const COLOR_DKSFC_ALERT_RED = "#ff6161";
const COLOR_DKSFC_ALERT_RED_BG = "#130202";
const COLOR_DKSFC_ALERT_RED_TEXT = "#FF9494";
const COLOR_LTSFC_WARNING_YELLOW = "#e39907";
const COLOR_LTSFC_WARNING_YELLOW_BG = "#fffbf5";
const COLOR_LTSFC_WARNING_YELLOW_TEXT = "#724d03";
const COLOR_DKSFC_WARNING_YELLOW = "#ffc758";
const COLOR_DKSFC_WARNING_YELLOW_BG = "#140e00";
const COLOR_DKSFC_WARNING_YELLOW_TEXT = "#ffd88a";
const COLOR_LTSFC_SUCCESS_GREEN = "#3a825c";
const COLOR_LTSFC_SUCCESS_GREEN_BG = "#f8fcfa";
const COLOR_LTSFC_SUCCESS_GREEN_TEXT = "#2a5f43";
const COLOR_DKSFC_SUCCESS_GREEN = "#5eb886";
const COLOR_DKSFC_SUCCESS_GREEN_BG = "#060e0a";
const COLOR_DKSFC_SUCCESS_GREEN_TEXT = "#95d0af";
const COLOR_LTSFC_INFORMATION_BLUE = "#0074e0";
const COLOR_LTSFC_INFORMATION_BLUE_BG = "#f5faff";
const COLOR_LTSFC_INFORMATION_BLUE_TEXT = "#003f7a";
const COLOR_DKSFC_INFORMATION_BLUE = "#3ba1ff";
const COLOR_DKSFC_INFORMATION_BLUE_BG = "#000b14";
const COLOR_DKSFC_INFORMATION_BLUE_TEXT = "#a3d3ff";
const COLOR_LTSFC_ONBOARDING_INDIGO = "#525bb8";
const COLOR_LTSFC_ONBOARDING_INDIGO_BG = "#eeeff8";
const COLOR_DKSFC_ONBOARDING_INDIGO = "#757cc7";
const COLOR_DKSFC_ONBOARDING_INDIGO_BG = "#101225";
const COLOR_FOCUS_RING = "#0074E0";
const COLOR_LIGHT_TEAL = "#009CA9";
const COLOR_LIGHT_TEAL_SHADE = "#006170";
const COLOR_LIGHT_SLATE = "#024B79";
const COLOR_LIGHT_SLATE_SHADE = "#003557";
const COLOR_LIGHT_VIOLET = "#623C8A";
const COLOR_LIGHT_VIOLET_SHADE = "#32184E";
const COLOR_LIGHT_BLUE = "#5293BF";
const COLOR_LIGHT_BLUE_SHADE = "#206696";
const COLOR_LIGHT_HOVER_OVERLAY = "rgba(16, 16, 16, 0.04)";
const COLOR_LIGHT_FOCUS_OVERLAY = "rgba(16, 16, 16, 0.12)";
const COLOR_LIGHT_SELECTED_OVERLAY = "rgba(16, 16, 16, 0.08)";
const COLOR_DARK_TEAL = "#17D4E3";
const COLOR_DARK_TEAL_SHADE = "#9DDDE3";
const COLOR_DARK_SLATE = "#277AAC";
const COLOR_DARK_SLATE_SHADE = "#6CAED6";
const COLOR_DARK_VIOLET = "#794AAA";
const COLOR_DARK_VIOLET_SHADE = "#A98BC9";
const COLOR_DARK_BLUE = "#5FB3EA";
const COLOR_DARK_BLUE_SHADE = "#A8DCFE";
const COLOR_DARK_HOVER_OVERLAY = "rgba(255, 255, 255, 0.08)";
const COLOR_DARK_FOCUS_OVERLAY = "rgba(255, 255, 255, 0.32)";
const COLOR_DARK_SELECTED_OVERLAY = "rgba(255, 255, 255, 0.16)";

const SHADOW_1 = `0px 1px 1px -2px rgba(16, 16, 16, 0.2), 0px 2px 2px rgba(16, 16, 16, 0.14), 0px 1px 5px rgba(16, 16, 16, 0.12);`;
const SHADOW_2 = `0px 3px 5px -1px rgba(16, 16, 16, 0.2), 0px 6px 10px rgba(16, 16, 16, 0.14), 0px 1px 18px rgba(16, 16, 16, 0.12)`;
const SHADOW_3 = `0px 7px 8px -4px rgba(16, 16, 16, 0.2), 0px 12px 17px 2px rgba(16, 16, 16, 0.14), 0px 5px 22px 4px rgba(16, 16, 16, 0.12)`;
const SHADOW_4 = `0px 11px 15px -7px rgba(16, 16, 16, 0.2), 0px 16px 38px 3px rgba(16, 16, 16, 0.14), 0px 9px 46px 8px rgba(16, 16, 16, 0.12)`;

const SPACING_4 = 4;
const SPACING_8 = 8;
const SPACING_12 = 12;
const SPACING_16 = 16;
const SPACING_24 = 24;
const SPACING_32 = 32;
const SPACING_40 = 40;
const SPACING_48 = 48;

const FONT_BODY = `Mark Pro, system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif,
'Apple Color Emoji', 'Segoe UI Emoji'`;

export { COLOR_CATAPULT_BLACK, COLOR_CATAPULT_ORANGE, COLOR_CATAPULT_WHITE, COLOR_DARK_BLUE, COLOR_DARK_BLUE_SHADE, COLOR_DARK_FOCUS_OVERLAY, COLOR_DARK_HOVER_OVERLAY, COLOR_DARK_SELECTED_OVERLAY, COLOR_DARK_SLATE, COLOR_DARK_SLATE_SHADE, COLOR_DARK_TEAL, COLOR_DARK_TEAL_SHADE, COLOR_DARK_VIOLET, COLOR_DARK_VIOLET_SHADE, COLOR_DKSFC_ALERT_RED, COLOR_DKSFC_ALERT_RED_BG, COLOR_DKSFC_ALERT_RED_TEXT, COLOR_DKSFC_INFORMATION_BLUE, COLOR_DKSFC_INFORMATION_BLUE_BG, COLOR_DKSFC_INFORMATION_BLUE_TEXT, COLOR_DKSFC_ONBOARDING_INDIGO, COLOR_DKSFC_ONBOARDING_INDIGO_BG, COLOR_DKSFC_SUCCESS_GREEN, COLOR_DKSFC_SUCCESS_GREEN_BG, COLOR_DKSFC_SUCCESS_GREEN_TEXT, COLOR_DKSFC_WARNING_YELLOW, COLOR_DKSFC_WARNING_YELLOW_BG, COLOR_DKSFC_WARNING_YELLOW_TEXT, COLOR_FOCUS_RING, COLOR_GREY_1, COLOR_GREY_2, COLOR_GREY_3, COLOR_GREY_4, COLOR_GREY_5, COLOR_GREY_6, COLOR_GREY_7, COLOR_INDIGO_1, COLOR_INDIGO_2, COLOR_INDIGO_3, COLOR_INDIGO_4, COLOR_INDIGO_5, COLOR_LIGHT_BLUE, COLOR_LIGHT_BLUE_SHADE, COLOR_LIGHT_FOCUS_OVERLAY, COLOR_LIGHT_HOVER_OVERLAY, COLOR_LIGHT_SELECTED_OVERLAY, COLOR_LIGHT_SLATE, COLOR_LIGHT_SLATE_SHADE, COLOR_LIGHT_TEAL, COLOR_LIGHT_TEAL_SHADE, COLOR_LIGHT_VIOLET, COLOR_LIGHT_VIOLET_SHADE, COLOR_LTSFC_ALERT_RED, COLOR_LTSFC_ALERT_RED_BG, COLOR_LTSFC_ALERT_RED_TEXT, COLOR_LTSFC_INFORMATION_BLUE, COLOR_LTSFC_INFORMATION_BLUE_BG, COLOR_LTSFC_INFORMATION_BLUE_TEXT, COLOR_LTSFC_ONBOARDING_INDIGO, COLOR_LTSFC_ONBOARDING_INDIGO_BG, COLOR_LTSFC_SUCCESS_GREEN, COLOR_LTSFC_SUCCESS_GREEN_BG, COLOR_LTSFC_SUCCESS_GREEN_TEXT, COLOR_LTSFC_WARNING_YELLOW, COLOR_LTSFC_WARNING_YELLOW_BG, COLOR_LTSFC_WARNING_YELLOW_TEXT, COLOR_ORANGE_1, COLOR_ORANGE_2, COLOR_ORANGE_3, COLOR_ORANGE_4, COLOR_ORANGE_5, COLOR_ORANGE_6, FONT_BODY, MIN_WIDTH_LG, MIN_WIDTH_MD, MIN_WIDTH_XL, SHADOW_1, SHADOW_2, SHADOW_3, SHADOW_4, SPACING_12, SPACING_16, SPACING_24, SPACING_32, SPACING_4, SPACING_40, SPACING_48, SPACING_8 };
//# sourceMappingURL=index.es.js.map
